import { useRef, useEffect, useState, useCallback } from "react";
import { StriimInputField, StriimForm, StriimTypography } from "@striim/striim-ui";
import * as Yup from "yup";
import { makeStyles } from "@material-ui/core/styles";
import { mapOptions } from "../utils";
import VaultsService from "../vaults/vaults-service";

const useStyles = makeStyles(() => ({
    container: {
        marginBottom: 28
    }
}));

const AddPropertyVariableModalContent = ({ setFormValues, setIsValid }) => {
    const classes = useStyles();
    const [options, setOptions] = useState([]);

    const values = {
        name: "",
        value: "",
        nsName: ""
    };

    const formRef = useRef();
    const validationSchema = Yup.object().shape({
        name: Yup.string().required("Required"),
        value: Yup.string().required("Required"),
        nsName: Yup.string().required("Required")
    });

    const getOptions = useCallback(options => mapOptions(options), [options]);

    useEffect(() => {
        async function fetchData() {
            const theData = await VaultsService.getNamespaces();
            setOptions(theData?.models);
        }

        if (!options.length) {
            fetchData();
        }
    }, [options]);

    return (
        <StriimForm values={values} validationSchema={validationSchema} formRef={formRef} validateOnMount={true}>
            {({ values, isValid }) => {
                setFormValues(values);
                setIsValid(isValid);
                return (
                    <>
                        <div
                            style={{
                                marginBottom: 16
                            }}
                        >
                            <StriimTypography variant="body4" color="greyscale.600">
                                Property Variables allow you to store values for adapter properties in an encrypted form
                            </StriimTypography>
                        </div>
                        <StriimInputField
                            required
                            name="name"
                            label="Property Variable Name"
                            placeholder="Enter property variable name"
                            id="data-test-name"
                            isFormElement
                            className={classes.container}
                        />
                        <div
                            style={{
                                marginBottom: 16
                            }}
                        />
                        <StriimInputField
                            required
                            name="value"
                            label="Property Variable Value"
                            type="password"
                            placeholder="Enter property variable value"
                            isFormElement
                            helperText="This value will be encrypted and will not be shown after save"
                            id="data-test-value"
                            className={classes.container}
                            previewPassword
                        />

                        <div
                            style={{
                                marginBottom: 16
                            }}
                        />
                        <StriimInputField
                            required
                            name="nsName"
                            label="Namespace"
                            select
                            id="data-test-id-namespace-select"
                            placeholder="Enter namespace"
                            SelectProps={{ options: getOptions(options), menuPosition: "fixed" }}
                            isFormElement
                        />
                    </>
                );
            }}
        </StriimForm>
    );
};

export default AddPropertyVariableModalContent;
